import moment from "moment/moment";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiPath from "../../Utils/apiPath";
import { apiGet } from "../../Utils/apiFetch";
import { debounce, isEmpty, startCase, upperCase } from "lodash";
import GameRecordFilter from "./GameRecordFilter";
import { FaCalendarAlt } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import InternalLoader from "../../component/InternalLoader";
import { toFixedWithoutRounding } from "../../Utils/Toast";
const GameRecord = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState({
    status: false,
    type: "",
  });
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({
    betType: "BetFair",
    status: "completed",
    fromPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
    toPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
    page: 1,
    limit: 50,
    tab: "sports",
  });
  let dummy = {
    BetFair: "betfair",
    Bookmaker: "bookmaker",
    Fancy: "fancy",
    SportsBook: "sportBook",
  };
  const getData = async (obj = filter) => {
    const { status, data } = await apiGet(apiPath.getHistory, {
      betType: obj?.tab == "Casino" ? "casino" : dummy[obj?.betType],
      status: "completed",
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page || 1,
      limit: obj?.limit,
    });
    if (status == 200) {
      if (data?.success) {
        if (data?.results?.data?.length > 0) {
          setData(data?.results?.data);
          setTotal(
            obj?.tab == "Casino"
              ? calculateTotalsCasino(data?.results?.data)
              : calculateTotals(data?.results?.data)
          );
        } else {
          setData([]);
          setTotal({});
        }
      }
    }
    setLoader(false);
  };

  const ShowPrice = (res) => {
    if (isEmpty(res?.fancyName)) {
      if (
        (res?.teamSelectionWin == res?.selectionId && res?.betType == "back") ||
        (res?.teamSelectionWin != res?.selectionId && res?.betType == "lay")
      ) {
        return res?.profitAmount;
      } else {
        return -res?.loseAmount;
      }
    } else {
      if (res?.type == "No") {
        if (res?.decisionRun < res?.betRun) {
          return res?.profitAmount;
        } else {
          return -res?.loseAmount;
        }
      } else {
        if (res?.decisionRun >= res?.betRun) {
          return res?.profitAmount;
        } else {
          return -res?.loseAmount;
        }
      }
    }
  };
  function calculateTotalsCasino(bets) {
    let totalAmount = 0;
    let profitLoss = 0;
    let totalOdds = 0;
    bets.forEach((res) => {
      totalAmount += res.betAmount;
      profitLoss += parseFloat(res.playerPL);
    });

    return {
      totalAmount,
      profitLoss,
      totalOdds,
    };
  }
  function calculateTotals(bets) {
    let totalAmount = 0;
    let profitLoss = 0;
    let totalOdds = 0;
    bets.forEach((res) => {
      totalAmount += res.amount;
      totalOdds += parseFloat(res.bhav || 0); // safely parse bhav as float
      let isFancy = !!res.fancyName; // fancyName presence check

      if (!isFancy) {
        const isBackWin =
          res.teamSelectionWin == res.selectionId && res.betType === "back";
        const isLayWin =
          res.teamSelectionWin != res.selectionId && res.betType === "lay";

        if (isBackWin || isLayWin) {
          profitLoss += res.profitAmount;
        } else {
          profitLoss -= res.loseAmount;
        }
      } else {
        // Fancy logic
        const isNo = res.type === "No";

        if (isNo) {
          if (res.decisionRun < res.betRun) {
            profitLoss += res.profitAmount;
          } else {
            profitLoss -= res.loseAmount;
          }
        } else {
          if (res.decisionRun >= res.betRun) {
            profitLoss += res.profitAmount;
          } else {
            profitLoss -= res.loseAmount;
          }
        }
      }
    });

    return {
      totalAmount,
      profitLoss,
      totalOdds,
    };
  }

  // Debounce wrapper to avoid multiple API calls
  const debouncedFetch = useCallback(
    debounce((obj) => {
      getData(obj);
    }, 500), // wait 600ms
    []
  );

  // Trigger API when filter changes but debounced
  useEffect(() => {
    setLoader(true);
    debouncedFetch(filter);
  }, [filter]);
  let obj = {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  };
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="mc-game-record-root">
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-gameRecord mc-default-header am-navbar am-navbar-light"
          >
            <div
              onClick={() => navigate(-1)}
              className="am-navbar-left"
              role="button"
            >
              <span className="am-navbar-left-content">
                <span className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title" style={{ justifyContent: "end" }}>
              Betting Record
            </div>
            <div className="am-navbar-right">
              {/* <div className="exclude-btn">Exclusion turnover list</div> */}
            </div>
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <div>
          <div className="am-tabs am-tabs-top i18n-fix mc-tabs-scroll">
            <div className="mc-tab-container" id="mc-tab-container">
              <div
                onClick={() => {
                  setData([]);
                  setTotal({});
                  setFilter((prev) => {
                    return { ...prev, tab: "Casino" };
                  });
                }}
                className={`${
                  filter?.tab == "Casino" ? "tab-active" : ""
                }  mc-tab-item`}
              >
                <span>Casino</span>
              </div>
              {/* <div
                  onClick={() =>
                    setFilter((prev) => {
                      return { ...prev, tab: "live" };
                    })
                  }
                  className={`${
                    filter?.tab == "live" ? "tab-active" : ""
                  }  mc-tab-item`}
                >
                  <span>Live</span>
                </div>
                <div
                  onClick={() =>
                    setFilter((prev) => {
                      return { ...prev, tab: "fish" };
                    })
                  }
                  className={`${
                    filter?.tab == "fish" ? "tab-active" : ""
                  }  mc-tab-item`}
                >
                  <span>Fish</span>
                </div>
                <div
                  onClick={() =>
                    setFilter((prev) => {
                      return { ...prev, tab: "poker" };
                    })
                  }
                  className={`${
                    filter?.tab == "poker" ? "tab-active" : ""
                  }  mc-tab-item`}
                >
                  <span>Poker</span>
                </div> */}
              <div
                onClick={() => {
                  setData([]);
                  setTotal({});
                  setFilter((prev) => {
                    return { ...prev, tab: "sports" };
                  });
                }}
                className={`${
                  filter?.tab == "sports" ? "tab-active" : ""
                }  mc-tab-item`}
              >
                <span>Sports</span>
              </div>
              {/* <div
                  onClick={() =>
                    setFilter((prev) => {
                      return { ...prev, tab: "lottery" };
                    })
                  }
                  className={`${
                    filter?.tab == "lottery" ? "tab-active" : ""
                  }  mc-tab-item`}
                >
                  <span>Lottery</span>
                </div> */}
            </div>
            <div className="am-tabs-content am-tabs-content-no-animated">
              <div
                role="tabpanel"
                aria-hidden="false"
                className="am-tabs-tabpane am-tabs-tabpane-active"
              >
                <div className="main game-record-wrapper RNG">
                  <div className="chooser-mask" />
                  <div className="am-flexbox am-flexbox-align-middle mc-trans-filter  mc-filter ">
                    <div className="am-flexbox am-flexbox-align-middle mc-trans-filter ">
                      <div
                        onClick={() =>
                          setShow({
                            status: true,
                            type: "range",
                          })
                        }
                        className="flex-shrink1 filter-time-btn"
                      >
                        <a
                          role="button"
                          className="am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                          aria-disabled="false"
                          style={{
                            "-webkit-flex": "0 0 50%",
                            "-ms-flex": "0 0 50%",
                            flex: "0 0 50%",
                          }}
                        >
                          <FaCalendarAlt className="am-icon am-icon-calendar_c4db3b67 am-icon-xxs" />
                          <span>
                            {moment(filter?.fromPeriod).format(
                              "MM/DD HH:mm:ss"
                            )}
                            -{" "}
                            {moment(filter?.toPeriod).format("MM/DD HH:mm:ss")}
                          </span>
                        </a>
                      </div>
                      {filter?.tab != "Casino" && (
                        <a
                          onClick={() =>
                            setShow({
                              status: true,
                              type: "vendor",
                            })
                          }
                          role="button"
                          className="vasslage-btn am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                          aria-disabled="false"
                        >
                          <IoIosArrowDown className="am-icon am-icon-down am-icon-xxs" />
                          <span>{filter?.betType}</span>
                        </a>
                      )}
                    </div>
                  </div>
                  <div>
                    <div
                      className="padding-bottom-2rem"
                      style={{ overflow: "hidden" }}
                    >
                      <div
                        className="gameCecords-list-root"
                        style={{ background: "rgb(245, 245, 245)" }}
                      />
                      <div className="list-wrapper">
                        <ul className="scroll-inner-container">
                          {data?.length > 0 ? (
                            data?.map((res) => {
                              return (
                                <li>
                                  <div className="lott-records-root">
                                    <div className="records-item-header-sy">
                                      <div
                                        className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle"
                                        style={{
                                          height: "0.5rem",
                                          width: "100%",
                                        }}
                                      >
                                        <div className="am-flexbox am-flexbox-dir-row am-flexbox-align-middle">
                                          <i
                                            style={{
                                              width: "0.2rem",
                                              height: "0.2rem",
                                              marginRight: "0.2rem",
                                              display: "inline-block",
                                              borderRadius: "50%",
                                              background: "rgb(16, 142, 233)",
                                            }}
                                          />
                                          <div
                                            className="mc_common_overflow"
                                            style={{ fontWeight: 600 }}
                                          >
                                            {res?.teamName ||
                                              res?.fancyName ||
                                              res?.casinoName}
                                          </div>
                                        </div>
                                        <div
                                          className="record_date"
                                          style={{ fontSize: "0.26rem" }}
                                        >
                                          {moment(res?.timeInserted).format(
                                            "YYYY-MM-DD hh:mm:ss"
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="records-item-content-sy">
                                      {/* <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-top" /> */}
                                      <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-top">
                                        <span>
                                          Event Name:
                                          <span className="order-number-group">
                                            <span className="title">
                                              {res?.matchName ||
                                                res?.casinoName}{" "}
                                              |{" "}
                                              {obj[res?.eventType] ||
                                                res?.platform}{" "}
                                              |{" "}
                                              {filter?.tab == "Casino"
                                                ? upperCase(res?.casinoType)
                                                : filter?.betType == "BetFair"
                                                ? "Match Odds"
                                                : startCase(filter?.betType)}
                                            </span>
                                          </span>
                                        </span>{" "}
                                      </div>
                                      <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-top">
                                        <span>
                                          Order no.:
                                          <span className="order-number-group">
                                            <span className="title">
                                              {res?.matchBetId ||
                                                res?.casinoBetId}
                                            </span>
                                          </span>
                                        </span>
                                      </div>
                                      <div className="am-flexbox am-flexbox-justify-between am-flexbox-align-middle">
                                        <span>
                                          Bet amount :{" "}
                                          {res?.amount || res?.betAmount}
                                        </span>
                                        {filter?.tab != "Casino" && (
                                          <span>Odds : {res?.bhav}</span>
                                        )}
                                      </div>
                                      <div className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle">
                                        <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-between am-flexbox-align-top">
                                          <span className="time">
                                            Profit and loss
                                          </span>

                                          <span
                                            className={`${
                                              (filter?.tab == "Casino"
                                                ? toFixedWithoutRounding(
                                                    res?.playerPL
                                                  )
                                                : ShowPrice(res)) > 0
                                                ? "loss-amount"
                                                : "win-amount"
                                            }  record-amount`}
                                          >
                                            {filter?.tab == "Casino"
                                              ? toFixedWithoutRounding(
                                                  res?.playerPL
                                                )
                                              : Math.abs(ShowPrice(res))}
                                          </span>
                                        </div>
                                        {/* <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-center am-flexbox-align-top">
                                            <span className="time">
                                              Winnings
                                            </span>
                                            <span className="amount-zero-number record-amount">
                                              -
                                            </span>
                                          </div> */}
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              );
                            })
                          ) : (
                            <div
                              className="nodata-container"
                              style={{ height: "607.609px" }}
                            >
                              <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                                <use xlinkHref="#nodata_f4c19c2d" />
                              </svg>
                              <p className>No data</p>
                            </div>
                          )}
                        </ul>
                        <div className="pullup-wrapper" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                aria-hidden="true"
                className="am-tabs-tabpane am-tabs-tabpane-inactive"
              />
              <div
                role="tabpanel"
                aria-hidden="true"
                className="am-tabs-tabpane am-tabs-tabpane-inactive"
              />
              <div
                role="tabpanel"
                aria-hidden="true"
                className="am-tabs-tabpane am-tabs-tabpane-inactive"
              />
              <div
                role="tabpanel"
                aria-hidden="true"
                className="am-tabs-tabpane am-tabs-tabpane-inactive"
              />
              <div
                role="tabpanel"
                aria-hidden="true"
                className="am-tabs-tabpane am-tabs-tabpane-inactive"
              />
            </div>
          </div>

          <div>
            <div className="betting-footer-wrap record-footer">
              <div className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle total-money">
                <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-center am-flexbox-align-top total-money-item">
                  <span className="time">Bet amount</span>
                  <span
                    className="loss-amount"
                    style={{ "font-weight": "700", "font-size": "0.24rem" }}
                  >
                    {toFixedWithoutRounding(total?.totalAmount)}
                  </span>
                </div>
                {filter?.tab != "Casino" && (
                  <>
                    {" "}
                    <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-center am-flexbox-align-top total-money-item">
                      <span className="time">Valid bet</span>
                      <span
                        className="loss-amount"
                        style={{
                          "font-weight": "700",
                          "font-size": "0.24rem",
                        }}
                      >
                        {toFixedWithoutRounding(total?.totalOdds)}
                      </span>
                    </div>
                    <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-center am-flexbox-align-top total-money-item">
                      <span className="time">Winnings</span>
                      <span
                        className="loss-amount"
                        style={{
                          "font-weight": "700",
                          "font-size": "0.24rem",
                        }}
                      >
                        0
                      </span>
                    </div>
                  </>
                )}

                <div className="am-flexbox am-flexbox-dir-column am-flexbox-justify-center am-flexbox-align-top total-money-item">
                  <span className="time">Profit and loss</span>
                  <span
                    className={
                      total?.profitLoss > 0 ? "loss-amount" : "win-amount"
                    }
                    style={{ "font-weight": "700", "font-size": "0.24rem" }}
                  >
                    {toFixedWithoutRounding(total?.profitLoss)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {show?.status && !isEmpty(show?.type) && (
        <GameRecordFilter
          type={show?.type}
          setFilter={setFilter}
          setShow={setShow}
          filter={filter}
          page={"history"}
        />
      )}
      {loader && <InternalLoader />}
    </div>
  );
};

export default GameRecord;
